var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2139 11.2037C12.423 11.2037 14.2139 9.41287 14.2139 7.20374C14.2139 4.9946 12.423 3.20374 10.2139 3.20374C8.00473 3.20374 6.21387 4.9946 6.21387 7.20374C6.21387 9.41287 8.00473 11.2037 10.2139 11.2037Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5639 13.2137C7.83387 13.1137 2.21387 14.4737 2.21387 17.2037V18.2037C2.21387 18.7537 2.66387 19.2037 3.21387 19.2037H11.7539C9.28387 16.4437 10.5239 13.3137 10.5639 13.2137Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6439 17.2237C20.1139 16.4237 20.3439 15.4537 20.1239 14.4037C19.7839 12.7637 18.4039 11.4537 16.7439 11.2437C14.1139 10.9037 11.8939 13.1137 12.2439 15.7437C12.4639 17.4037 13.7639 18.7837 15.4039 19.1237C16.4539 19.3437 17.4239 19.1137 18.2239 18.6437L20.0839 20.5037C20.4739 20.8937 21.1039 20.8937 21.4939 20.5037C21.8839 20.1137 21.8839 19.4837 21.4939 19.0937L19.6439 17.2237ZM16.2139 17.2037C15.1139 17.2037 14.2139 16.3037 14.2139 15.2037C14.2139 14.1037 15.1139 13.2037 16.2139 13.2037C17.3139 13.2037 18.2139 14.1037 18.2139 15.2037C18.2139 16.3037 17.3139 17.2037 16.2139 17.2037Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSearch);
export default __webpack_public_path__ + "static/media/person-search.514c7d7abf6a7429e1305ceb28abc3c0.svg";
export { ForwardRef as ReactComponent };